import {useState} from 'react';

const useWizard = ({skipStep,localStorageKey,runOnNext=()=>{}}) => {
    const [activeStep, setActiveStep] = useState(()=>{
        // const localData = sessionStorage?.getItem(localStorageKey);
        // return localData ? JSON.parse(localData) : 0;
        return 0;
    });

    // useEffect(()=>{
    //     if(localStorageKey){
    //         sessionStorage?.setItem(localStorageKey,activeStep)
    //     }
    //     return ()=>{
    //         if(localStorageKey){
    //             sessionStorage?.removeItem(localStorageKey)
    //         }
    //     }
    // },[activeStep,localStorageKey])

    const handleNext = (values) => {
        runOnNext(values)
        const steps = activeStep + 1 === skipStep ? 2 : 1
        setActiveStep((prevActiveStep) => prevActiveStep + steps);
    };

    const handleBack = () => {
        const steps = activeStep - 1 === skipStep ? 2 : 1
        setActiveStep((prevActiveStep) => prevActiveStep - steps);
    };

    const gotoStep = (step) => {
        setActiveStep(step);
    };
    return {activeStep, handleBack, handleNext, gotoStep}
}

export default useWizard;